













































































import {
  Component, Vue, Prop, Ref, Watch,
} from 'vue-property-decorator';
import LabelCanvas from '@/vuejs/components/canvas/LabelCanvas.vue';
import ColorGenerator from '@/components/canvas-addons/ColorGenerator.vue';
import BCanvasCursor from '@/components/behaviors/player/BCanvasCursor.vue';
import BSeekOnShiftClick from '@/components/behaviors/player/BSeekOnShiftClick.vue';
import BCreateOnCanvasDrag from '@/components/behaviors/analysis/BCreateOnCanvasDrag.vue';
import BResizeOnArrowDrag from '@/components/behaviors/analysis/BResizeOnArrowDrag.vue';
import BMoveOnDrag from '@/components/behaviors/analysis/BMoveOnDrag.vue';
import BSelectOnClick from '@/components/behaviors/shared/BSelectOnClick.vue';

import type {
  Piece, Audio, Onset, Second,
} from '@/data';
import { Analysis } from '@/data';

import { Client } from '@/client';
import type AnalysisActions from '@/logic/AnalysisActions';
import AnalysisActionsImpl from '@/logic/AnalysisActionsImpl';
import FilePlayerContainer from '@/components/players/FilePlayerContainer.vue';
import CanvasSourceBase from '@/vuejs/components/canvas-sources/CanvasSourceBase.vue';
import type { ImageLikeSource } from '@/data/Source';

@Component({
  components: {
    CanvasSourceBase,
    LabelCanvas,
    ColorGenerator,
    BCanvasCursor,
    BSeekOnShiftClick,
    BCreateOnCanvasDrag,
    BResizeOnArrowDrag,
    BMoveOnDrag,
    FilePlayerContainer,
    BSelectOnClick,
  },
})
export default class DezrannCanvas extends Vue {
  @Prop()
  piecePath!: string;

  @Prop()
  baseUrl!: string;

  @Prop()
  analysisId!: string;

  @Prop({ default: 0 })
  sourceId!: number;

  @Prop({ default: 0 })
  audioIndex!: number;

  @Prop({ default: 0 as Onset })
  onset!: Onset;

  @Prop({ default: false })
  playing!: boolean;

  @Prop({ default: 0.5 })
  zoom!: number;

  @Prop({ default: '500px' })
  width!: string;

  @Prop()
  height!: string;

  @Ref('track')
  track?: HTMLAudioElement;

  @Ref('player')
  player?: FilePlayerContainer;

  piece: Piece | null = null;

  source: ImageLikeSource | null = null;

  analysis: Analysis | null = null;

  actions: AnalysisActions | null = null;

  audioTrack: Audio | null = null;

  musicalTime: Onset = 0 as Onset;

  realTime: Second | null = null;

  isDragging = false;

  async mounted() {
    const req = await this.client.loadPiece(this.piecePath, true);
    this.piece = req.data;
    this.audioTrack = this.piece.tracks[this.audioIndex];
    this.loadSource();
    this.loadAnalysis();
  }

  loadSource() {
    if (!this.piece) return;

    this.source = this.piece.sources[this.sourceId];
    if (!this.source) throw new Error(`Could not load source: ${this.sourceId}`);

    this.source.addDefaultLines();
  }

  @Watch('onset')
  onsetHandler() {
    this.player?.setMusicalTime(this.onset);
  }

  setTime(time: Onset) {
    this.$emit('time-change', time);
    this.player?.setMusicalTime(time);
  }

  async loadAnalysis() {
    if (!this.piece) return;

    if (this.analysisId) {
      const req = await this.client.loadAnalysis(this.piece, this.analysisId);
      if (req.isOk()) this.analysis = req.data;
      // eslint-disable-next-line no-console
      else console.error(req);
    }
    if (!this.analysis) this.analysis = new Analysis([]);

    this.actions = new AnalysisActionsImpl(this.piece, this.analysis);
  }

  /** This Client need only the address of the server
   *
   * isLocalClient hack: the Client behavior is similar to the distClient
   * only when it’s not the ws.dezrann.net. This is needed because
   * there is some automatic things that appens to call the distClient.
   */
  get client(): Client {
    const isLocalClient = this.baseUrl !== 'https://ws.dezrann.net/';
    const staticRoute = isLocalClient ? undefined : 'static/resources';

    return new Client(
      this.baseUrl,
      undefined,
      undefined,
      isLocalClient,
      staticRoute,
    );
  }
}
